module.exports = __webpack_public_path__ + "img/wash-detail.a973f250.jpg";